<template>
  <div>
    <b-modal @hide="onModalClose" :hide-header="true" :hide-footer="true" :body-class="['p-0']" class="add-tag-modal" scrollable :no-close-on-backdrop="true" v-model="isNotification">
      <div class="modal-content p-30 notification-model-container" @click="hideDropdown">
        <img src="static/img/add.svg" class="rt-2-10 add-tag-modal__close-icon" @click="closeModal" />
        <h5 class="text-center th-model-header-label">
          Alert individuals on the study and site team based on an <br />
          outcome of this question.
        </h5>
        <div class="modal-body mb- pt-15 p-0">
          <div class="pb-19">
            <div class="form-group" style="margin-bottom: 0px !important;">
              <div id="progressSelectBox" class="multiselect filter-form-box">
                <div class="selectBox" @click.stop="showNotificationDropdown">
                  <div class="fakeclass notification-input">
                    <input :value="selectedNotificationLabel" name="notification" id="select-question" placeholder="Select notification choice" readonly="readonly" tabindex="10" class="form-control input-md th-comman-select-box" />
                  </div>
                  <div class="overSelect"></div>
                </div>
                <div id="showNotification" class="select-scroll activity-builder-select-options" v-if="isNotificationDropdown">
                  <div v-for="(value, key) in notificationTypes" :key="key" class="th-dcf-select-notification">
                    <label :value="key" id="Notification-value" class="pi-width notificationLabel pl-6" @click="onSelectNotificationClick(value, key)">
                      {{ value }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-md-12 p-0 Select-an-activity pb-19 m-0" v-if="notificationPayload.type != 'default'">
            <div class="multiselect filter-form-box" id="languageSelectBox" ref="languages-select">
              <div class="selectBox" @click.stop="showCheckboxesLanguage">
                <div class="fakeclass">
                  <input name="language" class="form-control input-md cursor-pointer d-block" :value="selectedStepName" id="select-question" readonly :tabindex="10" v-show="!isDisplayActivityStep" />
                </div>
                <div class="overSelect"></div>
              </div>
              <div
                id="showCheckboxesLanguage"
                class="select-scroll activity-builder-select-options"
                :class="{
                  'th_Comman_no_text_Label p-20': searchedLanguagesList.length === 0
                }"
                v-if="isDisplayActivityStep"
              >
                <input type="text" class="language-search-bar pl-8 mb-10" placeholder="Search for a step" v-model="searchedLanguage" v-if="searchedLanguagesList.length" @click.stop="" />
                <div v-if="searchedLanguagesList.length === 0">
                  {{ errorMsg }}
                </div>
                <div class="d-flex cursor-pointer th-dcf-activity-body" v-for="step in searchedLanguagesList" :key="step.id" @click.stop="onSelectStepClick(step)">
                  <div class="step-body pl-10 pb-5" :for="step.id">
                    <div class="activity-optional-step-label">
                      <span> Step {{ step.sequence }} - {{ step.type }} </span>
                      <span class="activity-dcf__optional-box ml-10 d-inline-box pt-2" v-if="step.isSkippable">
                        Optional
                      </span>
                    </div>
                    <div class="dcf-step-label">
                      {{ step.body }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="Select-an-activity pb-19 d-flex" v-if="notificationPayload.type === 'THRESHOLD' && notificationPayload.questionId != 'default'">
            <div class="pr-10">
              <div class="">
                <input type="number" class="form-control input-style" placeholder="Enter Minimum value" max="10000" v-model="notificationPayload.thresholdMin" />
              </div>
            </div>
            <div class="">
              <div class="">
                <input type="number" class="form-control input-style" placeholder="Enter maximum value" max="10000" v-model="notificationPayload.thresholdMax" />
              </div>
            </div>
          </div>
          <div class="Select-an-activity pb-19" v-if="notificationPayload.type === 'SPECIFIC_ANSWER' && selectedStepName != 'Select a step'">
            <select class="form-control mt-0 caret-down-icon" v-model="notificationPayload.answer">
              <option value="default" disabled>Select a option</option>
              <option v-for="(option, index) in activityStepOptions" :key="index" :value="option.body">
                {{ option.body }}
              </option>
            </select>
          </div>
          <div v-if="notificationPayload.type != 'default'" class="pb-7 color_666669">
            If selected, notify:
          </div>
        </div>
        <TeamListModal v-if="notificationPayload.type != 'default' && allUserList && allUserList.length" :userList="allUserList" :selectedUserList="notificationPayload.contacts" @onSelectUserChange="onSelectUserChange" />
        <div class="modal-footer m-auto pt-50">
          <button type="button" class="continue-btn-modal ml-10" data-dismiss="modal" :disabled="notificationPayload.type === 'default' || notificationPayload.questionId === 'default' || (notificationPayload.contacts && notificationPayload.contacts.length === 0)" @click="onSaveNotification(notificationPayload)">
            <span class="continue-btn-text">Save</span>
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TeamListModal from "./team-list-modal";
import $ from "jquery";
import _ from "lodash";

export default {
  props: {
    isNotification: Boolean,
    activityStepList: {
      type: Array
    },
    studyTeam: {
      type: Array
    },
    researchSites: {
      type: Array
    },
    siteTeamList: {
      type: Array
    },
    notificationTypes: {
      type: Object
    },
    notificationPayload: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      allUsers: [],
      activityStepOptions: [],
      isExpanded: false,
      selectedUser: "",
      selectedStepType: "default",
      modalShow: false,
      selectedNotification: "default",
      activityQuestionType: [],
      isDisplayNotificationBoxes: false,
      errorMsg: "",
      isDisplayActivityStep: false,
      searchedLanguage: "",
      languagesFilter: [],
      selectedStepName: "Select a step",
      eventListenerToHideActivityStepDropdown: null,
      isNotificationDropdown: false,
      selectedNotificationLabel: "",
      currentStepObject: null,
      allUserList: null
    };
  },
  watch: {
    "notificationPayload.type": {
      handler(val) {
        this.activityQuestionType = [];
        this.activityStepOptions = [];
        this.notificationPayload.questionId = "default";
        this.selectedStepName = "Select a step";
        this.handleNotificationTypeChange(val);
        this.onStepChange();
      }
    }
  },
  components: {
    TeamListModal
  },
  computed: {
    searchedLanguagesList() {
      if (!this.activityQuestionType) {
        return [];
      }
      if (!this.activityQuestionType.length) {
        return [];
      }
      if (this.searchedLanguage) {
        const searchResult =
          this.activityQuestionType &&
          this.activityQuestionType.filter(item => {
            return this.searchedLanguage
              .toLowerCase()
              .split(" ")
              .every(v => item.body && item.body.toLowerCase().includes(v));
          });
        return searchResult.length ? searchResult : this.activityQuestionType;
      } else {
        return this.activityQuestionType;
      }
    }
  },
  mounted() {
    // force page to load from top only
    window.scrollTo(0, 0);
    const _this = this;
    $(document).click(function() {
      _this.isExpanded = false;
    });
    this.allUsers = _.sortBy(_.unionBy(this.studyTeam, this.researchSites, this.siteTeamList, "id"), ["firstName", "lastName"]);
    if (this.allUsers.length) {
      const filterUserList =
        this.allUsers &&
        this.allUsers.map(user => ({
          firstName: user.firstName,
          lastName: user.lastName,
          userRole: user.userRole,
          id: user.id,
          isEmail: user.isEmail || false,
          isMobile: user.isMobile || false
        }));
      const contactList = this.notificationPayload.contacts;
      this.allUserList = filterUserList.map(item => {
        const item2 = contactList.find(i2 => i2.id === item.id);
        return item2 ? { ...item, ...item2 } : item;
      });
    }
    this.handleNotificationTypeChange(this.notificationPayload.type);
    this.hideLanguageCheckBox();
    this.setNotificationPayload();
    this.onActivityChange(this.notificationPayload.questionId);
  },
  destroyed() {
    document.removeEventListener("click", this.eventListenerToHideActivityStepDropdown);
  },
  methods: {
    onSelectUserChange(selectedUser) {
      if (selectedUser.length) {
        const userList =
          selectedUser &&
          selectedUser.map(user => ({
            id: user.id,
            isEmail: user.isEmail || false,
            isMobile: user.isMobile || false
          }));
        this.notificationPayload.contacts = userList;
      } else {
        this.notificationPayload.contacts = [];
      }
    },
    setNotificationPayload() {
      const { type, stepName, questionId } = this.notificationPayload;
      this.selectedNotificationLabel = this.notificationTypes[type];
      this.selectedStepName = stepName || "Select a step";
      this.activityQuestionType.filter(stepType => {
        if (stepType.id === questionId) {
          this.currentStepObject = stepType;
        }
      });
    },
    showNotificationDropdown() {
      this.isDisplayActivityStep = false;
      this.isNotificationDropdown = !this.isNotificationDropdown;
    },
    hideDropdown() {
      this.isDisplayActivityStep = false;
      this.isNotificationDropdown = false;
      this.isExpanded = false;
    },
    onSelectNotificationClick(val, key) {
      this.notificationPayload.type = key;
      this.selectedNotificationLabel = val;
      this.isNotificationDropdown = false;
    },
    hideLanguageCheckBox() {
      this.eventListenerToHideActivityStepDropdown = document.addEventListener(
        "click",
        event => {
          if (this.$refs["languages-select"] && this.$refs["languages-select"].contains(event.target)) {
          } else {
            this.isDisplayActivityStep = false;
          }
        },
        false
      );
    },
    showCheckboxesLanguage() {
      this.isNotificationDropdown = false;
      this.isDisplayActivityStep = !this.isDisplayActivityStep;
    },
    onStepChange() {
      this.errorMsg = "";
      if ((this.activityQuestionType && this.activityQuestionType.length < 1) || this.activityQuestionType === 0) {
        const { type } = this.notificationPayload;
        this.errorMsg = type === "THRESHOLD" ? "No available numeric steps" : type === "NO_ANSWER" ? "No available optional steps" : "No available steps";
      }
    },
    onSelectStepClick(step) {
      this.currentStepObject = step;
      this.notificationPayload.questionId = step.id;
      this.selectedStepName = step.body;
      this.showCheckboxesLanguage();
      this.onActivityChange(step.id);
    },
    handleNotificationTypeChange(val) {
      if (val === "ANY_ANSWER") {
        this.activityQuestionType = this.activityStepList;
      } else if (val === "NO_ANSWER") {
        this.activityQuestionType = this.activityStepList && this.activityStepList.length && this.activityStepList.filter(stepType => stepType.isSkippable);
      } else if (val === "SPECIFIC_ANSWER") {
        this.activityStepList &&
          this.activityStepList.length &&
          this.activityStepList.filter(questionType => {
            if (questionType.type === "DropDown" || questionType.type === "Boolean" || questionType.type == "MultiChoice") {
              this.activityQuestionType.push(questionType);
            }
          });
      } else if (val === "THRESHOLD") {
        this.activityStepList &&
          this.activityStepList.length &&
          this.activityStepList.filter(step => {
            if (step.type === "Number" || step.type === "NumberScale" || step.type === "VAS") {
              this.activityQuestionType.push(step);
            }
          });
      }
    },
    onActivityChange(selectedActivityId) {
      this.activityStepOptions = [];
      this.activityStepList &&
        this.activityStepList.filter(step => {
          if (step.id === selectedActivityId) {
            if (step.options) {
              this.activityStepOptions = step.options;
            }
          }
        });
    },
    listToggle() {
      this.isExpanded = !this.isExpanded;
    },
    onUserChange(user) {
      this.notificationPayload.contacts[0].id = user.id;
      this.selectedUser = user.firstName + " " + user.lastName.charAt(0) + " " + "(" + _.upperCase(user.userRole) + ")";
      this.isExpanded = false;
    },
    onModalClose() {},
    closeModal() {
      this.$emit("onCloseNotification");
    },
    onSaveNotification(payload) {
      const isNotify = payload.contacts && payload.contacts.filter(user => !user.isMobile && !user.isEmail);
      if (isNotify.length > 0) {
        this.$toastr.error("At least one selection (either Email or SMS) is required.");
        return;
      }
      if (payload.type === "SPECIFIC_ANSWER" && payload.answer === "default") {
        this.$toastr.error("Please select a option.");
        return;
      }
      if (payload.type === "THRESHOLD") {
        if (!payload.thresholdMax || !payload.thresholdMin) {
          this.$toastr.error("Minimum and maximum values are required.");
          return;
        }
        if (this.currentStepObject && this.currentStepObject.maxValue && this.currentStepObject.minValue) {
          // min max should have value in defined range
          if (Number(payload.thresholdMin) < this.currentStepObject.minValue || Number(payload.thresholdMax) > this.currentStepObject.maxValue) {
            this.$toastr.error(`Min and Max values must be within ${this.currentStepObject.minValue} and ${this.currentStepObject.maxValue} range.`);
            return;
          }
        }
        if (Number(payload.thresholdMax) == Number(payload.thresholdMin)) {
          this.$toastr.error("Minimum and maximum values cannot be identical.");
          return;
        }
        // max values always less than min value
        if (Number(payload.thresholdMin) > Number(payload.thresholdMax)) {
          this.$toastr.error("Max value must be greater than Min value.");
          return;
        }
        if (Number(payload.thresholdMax) < Number(payload.thresholdMin)) {
          this.$toastr.error("Min value must be less than max value.");
          return;
        }
      }
      if (this.notificationPayload.answer === "default") {
        this.notificationPayload.answer = "";
      }
      if (this.notificationPayload.contacts[0].id === "default" || this.notificationPayload.contacts[0].id === "") {
        this.$toastr.error("User must be selected.");
        return;
      }
      this.$emit("onSaveNotification", payload);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/dropdown-css.scss";

.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}
.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
.select-scroll {
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */
}
.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}

#showCheckboxesLanguage {
  background: #fff;
  position: absolute;
  top: 50px;
  width: 100%;
  height: 180px;
  border-radius: 3px;
  padding: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 3;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

.th-dcf-activity-body {
  cursor: pointer !important;
  &:hover {
    background-color: #f5f8fa;
  }
}
#showCheckboxesLanguage .step-body {
  font-size: 14px;
  color: #000;
  margin-left: 0px;
  float: left;
  width: fit-content;
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .activity-optional-step-label {
    height: 24px;
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  .dcf-step-label {
    font-size: 13px;
    line-height: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .activity-dcf__optional-box {
    width: auto;
    padding: 3px 5px;
    border-radius: 4px;
    background-color: #c5d1d6;
    font-family: "RobotoRegular";
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
    text-align: center;
    vertical-align: middle;
  }
}
.language-search-bar {
  width: 100%;
  height: 28px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
}
.continue-btn-modal {
  width: 150px;
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  outline: none;
}
.continue-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.notification-model-container {
  width: 634px !important;
}
.add-tag-modal {
  .th-model-header-label {
    font-size: 18px !important;
  }
  .modal-dialog {
    vertical-align: top !important;
    width: 630px !important;
    top: 100px;
  }

  &__container {
    width: 902px;
    height: auto;
    border-radius: 4px;
    background-color: #ffffff;
    overflow: auto;
    position: relative;

    .fw-bold {
      font-weight: bold;
    }

    .color-black {
      color: black;
    }
  }

  &__name-input {
    width: 220px;
    height: 35px;
    border-radius: 3px;
    border: solid 1px #d3dfe4;
  }

  &__desc-input {
    width: 100%;
    height: 35px;
    border-radius: 3px;
    border: solid 1px #d3dfe4;
  }

  &__add-another-tag {
    font-family: "RobotoRegular";
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    color: #4c8ce4;
    cursor: pointer;
  }

  &__save-tag-btn {
    width: 102px;
    height: 35px;
    border-radius: 4px;
    background-color: #4c8ce4;
    color: white;
  }

  &__close-icon {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
}

.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}
.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
.select-scroll {
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */
}
.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}

#select-question {
  appearance: none !important;
  background-position: right 50% !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/arrow-down.png);
}

.notification-input .th-comman-select-box {
  color: #000 !important;
}
.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
#showNotification {
  position: absolute;
  top: 16px;
  z-index: 2;
  background: #fff;
  width: 100%;
  height: fit-content;
  border-radius: 4px;
  padding-bottom: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}
.th-dcf-select-notification {
  cursor: pointer !important;
  &:first-child {
    background-color: #f5f8fa;
  }
}
#showNotification label {
  font-size: 14px;
  color: #000;
  float: left;
  width: 275px;
  line-height: 30px;
  margin-bottom: 0px;
}
.pi-width {
  width: 100% !important;
  padding: 0 16px !important;
}
.form-control:disabled,
.form-control {
  background-color: #ffffff;
  opacity: 1;
}
#showNotification label:hover {
  background-color: #f5f8fa;
}
.th_Comman_no_text_Label {
  height: auto !important;
  color: #a8a5a5;
  font-weight: 500;
}
</style>
